// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"58f3b43c","51":"08ae15bc","414":"96bea03a","423":"41ee9d64","517":"647be4c1","865":"3c394859"}[chunkId] + ".css";
};